import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { TableModule } from 'primeng/table'
import { SharedModule } from '../shared/shared.module'
import { AutoCompleteModule } from 'primeng/autocomplete'
import { InputTextModule } from 'primeng/inputtext'
import { SelectModule } from 'primeng/select'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { ButtonModule } from 'primeng/button'
import { DialogModule } from 'primeng/dialog'
import { CheckboxModule } from 'primeng/checkbox'
import { TreeSelectModule } from 'primeng/treeselect'
import { TooltipModule } from 'primeng/tooltip'
import { ScrollingModule } from '@angular/cdk/scrolling'
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling'
import { OverlayPanelModule } from 'primeng/overlaypanel'
import { SelectButtonModule } from 'primeng/selectbutton'
import { InputNumberModule } from 'primeng/inputnumber'
import { MatSortModule } from '@angular/material/sort'
import { MatIconModule } from '@angular/material/icon'
import { MatTableModule } from '@angular/material/table'
import { MatGridListModule } from '@angular/material/grid-list'
import { MatRadioModule } from '@angular/material/radio'
import { BrowserModule } from '@angular/platform-browser'
import { ProgressBarModule } from 'primeng/progressbar'
import { MatStepperModule } from '@angular/material/stepper'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { NgApexchartsModule } from 'ng-apexcharts'
import { MatTooltipModule } from '@angular/material/tooltip'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { DVMToolDashboardComponent } from './dvm-tool-dashboard/dvm-tool-dashboard.component'
import { DVMToolPlanComponent } from './dvm-tool-plan/dvm-tool-plan.component'

@NgModule({
   declarations: [DVMToolDashboardComponent, DVMToolPlanComponent],
   imports: [
      CommonModule,
      SharedModule,
      AutoCompleteModule,
      ButtonModule,
      CheckboxModule,
      DialogModule,
      FormsModule,
      SelectModule,
      InputTextModule,
      TableModule,
      TreeSelectModule,
      TooltipModule,
      ScrollingModule,
      CdkVirtualScrollViewport,
      OverlayPanelModule,
      InputNumberModule,
      SelectButtonModule,
      MatSortModule,
      MatIconModule,
      MatTableModule,
      MatGridListModule,
      MatRadioModule,
      BrowserModule,
      MatTooltipModule,
      ProgressBarModule,
      MatStepperModule,
      MatFormFieldModule,
      ReactiveFormsModule,
      MatInputModule,
      NgApexchartsModule,
      BrowserAnimationsModule,
   ],
})
export class DvmToolModule {}
